import React from "react";
import useGlobalHook from "use-global-hook";
import * as actions from "../Actions/OrderActions";


const initialState = {
    status: 200,
    isLoading: false,
    message: "",
    header: {},
    data: [],
    usersStatus: [],
    lastPage: false,
    refresh: false
};

const OrderStore = useGlobalHook(React, initialState, actions);

export default OrderStore;
